import React, { useState } from 'react';
import styled from 'styled-components';
import Button from '../../Button';
import memoryService from '../../../services/memoryService';
import Toast from '../../Toast';

const StyledDeleteMemoryModal = styled.div`
  width: 100%;
  .desc {
    font-size: 18px;
    line-height: 22px;
    font-weight: 600;
    margin-bottom: 40px;
    color: var(--ink);

    @media (min-width: 576px) {
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 70px;
    }
  }
  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
`;

const DeleteMemoryModal = ({ onClose, data, refetch }) => {
  const [loading, setLoading] = useState(false);

  const handleMemoryDelete = async id => {
    try {
      setLoading(true);
      const resp = await memoryService.deleteMemory(id);
      if (resp?.success) {
        Toast({
          type: 'success',
          message: 'Memory Deleted Successfully',
        });
        setLoading(false);
        onClose();
        refetch();
      } else {
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error?.detail || 'Something went wrong!!!',
      });
      setLoading(false);
    }
  };

  return (
    <StyledDeleteMemoryModal>
      <h2 className="desc">Are you sure you want to delete this memory? There is no way to recover it.</h2>
      <div className="btn-holder">
        <Button width="102px" variant="secondary-outline" onClick={() => onClose()}>
          No
        </Button>
        <Button width="108px" onClick={() => handleMemoryDelete(data?.id)} loader={loading}>
          Yes
        </Button>
      </div>
    </StyledDeleteMemoryModal>
  );
};

export default DeleteMemoryModal;
